export enum CellPart {
    center = "center",
    corner = "corner",
    border = "border",
}
